export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-10 py-20">
      <div className="label-eyebrow mb-4">About</div>
      <h1 className="font-display text-5xl md:text-6xl leading-[0.95] tracking-tight mb-8">
        Fish clean. <span className="italic text-[#C95B3B]">Leave nothing behind.</span>
      </h1>
      <div className="space-y-6 text-lg leading-relaxed">
        <p>
          EcoFisherman started with a simple observation: the rules of the water are changing faster than the average
          angler can keep up. In September 2026, seven National Wildlife Refuges will require non-lead tackle.
          Yellowstone and Glacier already do. More parks and states are following.
        </p>
        <p>
          Our mission is to make the shift painless. We track the regulations, we vet the gear, and we tell the stories
          behind the waters worth protecting — so you can spend your time fishing, not sifting through federal rulebooks.
        </p>
        <p className="text-muted-foreground">
          We're an independent editorial team. Product links may be affiliate — we only feature what we'd tie on ourselves.
        </p>
      </div>
    </div>
  );
}
